export default __webpack_public_path__ + "static/media/ataur (3).567877d8.jpg";